import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LoaderBlue, LoaderScreen } from '../controls';

interface BoxLoaderProps {
  description?: string;
  isRunAsSimpleComponent: boolean;
  defaultLoader: boolean;
}

export const BoxLoader: FC<BoxLoaderProps> = ({
  description,
  isRunAsSimpleComponent = false,
  defaultLoader,
}) => {
  const { t } = useTranslation();

  return (
    <div className={isRunAsSimpleComponent ? 'credit__wrapper' : ''}>
      <div className={isRunAsSimpleComponent ? 'credit-block' : ''}>
        <div className={isRunAsSimpleComponent ? 'panel' : ''}>
          <div className="box-loader">
            {defaultLoader ? <LoaderScreen /> : <LoaderBlue />}
            <br />
            {description && (
              <p className="description text-center">
                <span className="title">{t(description)}</span>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
